import styled from "styled-components";
import Slider from "@material-ui/lab/Slider/Slider";
import TextField from "@material-ui/core/TextField/TextField";

export const ControlSlider = styled(Slider)`
    box-sizing: border-box;
`;

export const LatLngTextField = styled(TextField)`
    && {
        min-width: 100px;
        margin: 8px;
    }
`;

export const MiddleSliderWrapper = styled.div`
    @media (max-width: 600px) {
        margin: 0;
    }

    @media (min-width: 601px) {
        margin: 12px 0;
    }
`;



// WEBPACK FOOTER //
// ./src/common/Controls/Controls.sc.js